import { render, staticRenderFns } from "./CorporateInfo.vue?vue&type=template&id=36c0ba8a&"
import script from "./CorporateInfo.vue?vue&type=script&lang=js&"
export * from "./CorporateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports